import styled from 'styled-components';

export const CurrentProjectStyled = styled.div``;
